/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';
// @ts-ignore
import type { UserSettings } from './UserSettings';
// @ts-ignore
import {
// @ts-ignore
    UserSettingsFromJSON,
// @ts-ignore
    UserSettingsFromJSONTyped,
// @ts-ignore
    UserSettingsToJSON,
} from './UserSettings';

/**
 * 
 * @export
 * @interface UserCreateRequest
 */
export interface UserCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    currencyCode: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    mobileCountryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    mobileNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    languageCode: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    role: string;
    /**
     * 
     * @type {Status}
     * @memberof UserCreateRequest
     */
    status: Status;
    /**
     * 
     * @type {UserSettings}
     * @memberof UserCreateRequest
     */
    settings?: UserSettings;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    supplierId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    retailerId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateRequest
     */
    storeId?: string;
}

/**
 * Check if a given object implements the UserCreateRequest interface.
 */
// @ts-ignore
export function instanceOfUserCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "fullName" in value;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "languageCode" in value;
    isInstance = isInstance && "timezone" in value;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "organizationId" in value;

    return isInstance;
}

// @ts-ignore
export function UserCreateRequestFromJSON(json: any): UserCreateRequest {
    return UserCreateRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function UserCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCreateRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
        'password': json['password'],
        'email': json['email'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'fullName': json['full_name'],
        'currencyCode': json['currency_code'],
        'mobileCountryCode': !exists(json, 'mobile_country_code') ? undefined : json['mobile_country_code'],
        'mobileNumber': !exists(json, 'mobile_number') ? undefined : json['mobile_number'],
        'languageCode': json['language_code'],
        'timezone': json['timezone'],
        'role': json['role'],
        'status': StatusFromJSON(json['status']),
        'settings': !exists(json, 'settings') ? undefined : UserSettingsFromJSON(json['settings']),
        'organizationId': json['organization_id'],
        'supplierId': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'retailerId': !exists(json, 'retailer_id') ? undefined : json['retailer_id'],
        'storeId': !exists(json, 'store_id') ? undefined : json['store_id'],
    };
}

// @ts-ignore
export function UserCreateRequestToJSON(value?: UserCreateRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
        'email': value.email,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'full_name': value.fullName,
        'currency_code': value.currencyCode,
        'mobile_country_code': value.mobileCountryCode,
        'mobile_number': value.mobileNumber,
        'language_code': value.languageCode,
        'timezone': value.timezone,
        'role': value.role,
        'status': StatusToJSON(value.status),
        'settings': UserSettingsToJSON(value.settings),
        'organization_id': value.organizationId,
        'supplier_id': value.supplierId,
        'retailer_id': value.retailerId,
        'store_id': value.storeId,
    };
}

